const multiLineDataParser = (data: any, multiLine: boolean) => {
  if (multiLine && Array.isArray(data)) {
    return data;
  }
  return [
    {
      name: 'Series 1',
      data,
    },
  ];
};

export default multiLineDataParser;
